import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {map} from 'rxjs/operators';
import {FieldConfig} from '../dynamic-forms-components/field.interface';

@Component({
    selector: 'app-search-select',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <mat-form-field class="w-full demo-full-width margin-top" [hideRequiredMarker]="field?.hideRequiredMarker"
                        [formGroup]="group" appearance="outline">
            <mat-label>{{ field?.label }}</mat-label>
            <mat-select [placeholder]="field?.label" [formControlName]="field?.key"
                        (selectionChange)="selectionChange($event)" [multiple]="field.multiple" (focus)="focus()">
                <app-mat-select-search [(ngModel)]="searchValue" ngDefaultControl
                                       [ngModelOptions]="{standalone: true}"></app-mat-select-search>
                <ng-container *ngIf="hasFocus && field.useObservable && field.options">
          <span *ngIf="!field.removeUnderscore; else removeUnderScoreObservable">
            <mat-option
                    *ngFor="let item of (field.options | async) || [] | search: field.filterKey: filterVal | search: searchParameters: searchValue"
                    [value]="item.value">
              {{ item.name }}
          </mat-option>
          </span>
                </ng-container>
                <ng-container *ngIf="hasFocus && !field.useObservable && field.options">
        <span *ngIf="!field.removeUnderscore; else removeUnderScore">
          <mat-option
                  *ngFor="let item of field.options || [] | search: field.filterKey: filterVal | search: searchParameters: searchValue"
                  [value]="item.value">
              {{ item.name }}
          </mat-option>
        </span>
                </ng-container>
                <ng-template #removeUnderScore>
                    <mat-option
                            *ngFor="let item of field.options || [] | search: field.filterKey: filterVal | search: searchParameters: searchValue"
                            [value]="item.value">
                        {{ item.name | replace: '_' : ' ' }}
                    </mat-option>
                </ng-template>
                <ng-template #removeUnderScoreObservable>
                    <mat-option
                            *ngFor="let item of (field.options | async) || [] | search: field.filterKey: filterVal | search: searchParameters: searchValue"
                            [value]="item.value">
                        {{ item.name | replace: '_' : ' ' }}
                    </mat-option>
                </ng-template>
            </mat-select>
            <mat-hint><strong>{{ field.hint }}</strong></mat-hint>
            <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
                <mat-error *ngIf="group.get(field.key).hasError(validation.name)">{{ validation.message }}</mat-error>
            </ng-container>
        </mat-form-field>
    `,
    // host: {'class': 'col-md-6'},
    styles: ['.additional-selection { opacity: 0.75; font-size: 0.75em; }']
})
export class SearchSelectComponent implements OnInit {
    @Input() field: FieldConfig;
    @Input() group: FormGroup;
    @Output() selectedValue = new EventEmitter();


    searchValue = '';
    filterVal;
    searchParameters: string;
    hasFocus = false;
    hasManyOptions = false;

    // @HostBinding('class') rowClass = 'col-md-6';
    constructor() {
    }

    ngOnInit() {

        this.hasFocus = !((this.field.options || []).length > 50);
        //  this.rowClass = this.field.rowClass === 'large' ? 'col-md-12' : 'col-md-6';
        this.filterVal = this.group.get(this.field.filterValueKey) ? this.group.get(this.field.filterValueKey).value : null;
        //
        this.searchParameters = this.field.searchParameters ? this.field.searchParameters.join() : 'name';
    }


    selectionChange(event) {
        let object: any;
        if (this.field.useObservable) {
            object = this.field.options.pipe(map((items: any[]) => items.find(element => element.value == event.value)));
        } else {
            object = this.field.options.find(element => element.value == event.value);
        }
        this.selectedValue.emit({value: event.value, field: this.field, object});
    }

    focus() {
        this.hasFocus = true;
    }
}
